// @flow
import React, { type Node } from 'react';
import classnames from 'classnames';
import { isEmpty } from 'lodash';

import { Icon, type IconName } from 'Components/frameworks/icon/Icon.jsx';
import { TrackClick } from 'Tracking/track-click/TrackClick.jsx';

import { themes } from './ActionButtonsGroup.themes';

export type ActionButtonsGroupItemProps = {
  iconName?: IconName,
  id: string,
  isActive?: boolean,
  label: Node,
  number?: number,
  onClick: () => void,
  trackingData?: TrackingData,
};

type ActionButtonsGroupProps = {
  className?: string,
  isScrollable?: boolean,
  items: Array<ActionButtonsGroupItemProps>,
  minWidth?: string,
  theme?: string,
};

export function ActionButtonsGroup(props: ActionButtonsGroupProps) {
  const { className, isScrollable, items = [], minWidth = 'initial', theme = 'default' } = props;

  if (isEmpty(items)) return null;

  const { thRoot, thButton, thButtonActive, thIcon, thIconSize, thText, thNumber } = themes[theme]({
    isScrollable,
  });

  return (
    <div className={classnames(className, thRoot)}>
      {items.map(({ iconName, id, isActive, label, number, onClick, trackingData }) => (
        <TrackClick
          aria-disabled={isActive}
          as="button"
          className={isActive ? thButtonActive : thButton}
          key={id}
          onClick={onClick}
          style={{ minWidth }}
          trackingData={trackingData}
          type="button"
        >
          <Icon className={thIcon} name={iconName} width={thIconSize} />
          <span className={thText}>
            <span className={thNumber}>
              {number}
              <span> </span>
            </span>
            {label}
          </span>
        </TrackClick>
      ))}
    </div>
  );
}
